module.exports = __webpack_public_path__ + "img/ic_yccs_ok.bd2d8fcc.png";